// extracted by mini-css-extract-plugin
export default {"table_striped":"YDMQReport_table_striped__C3BDw"};